import angular from 'angular';
import builderUrl from './../../directives/builder/builder.directive.html';
import selectedFiltersUrl from './../selected-filters/selected-filters.component.html';
import SpiceIcoUrl from "../../../resources/icons/spice.svg";

/* @ngInject */
export default function TechnologyComponent($scope, $rootScope, $location, $timeout, $window, $translate, $uibModal, $log, CacheService, SideMenuCacheService, DefinitionParameterApiService,
                                            StepFileService, SpiceApiService, OctopartApiService, UniquePartApiService, BreadcrumbParserService, NavigationService,
                                            NotifyingService, ParameterApiService, SleuthService, TechnologyService, SpinnerLoadingService, UniquePartModelService,
                                            DefinitionModelService, ImageProcessorService, PartCountFormatterService, ContainerInfoApiService, __env, APP_ROUTES, PartNumberFormatterService,
                                            DocFinderFileService, ParameterSupportService) {
    //Similar products
    $scope.sleuthService = SleuthService;
    $scope.isBrowseCtrl = false;
    $scope.isTechnologyCtrl = true;
    $scope.isHomeCtrl = false;
    $scope.isDistributorCtrl = false;
    $scope.builderDirectiveView = builderUrl;
    $scope.selectedFiltersComponent = selectedFiltersUrl;

    $scope.similarProducts = [];
    $scope.responsiveSlickSettings = [
        {
            breakpoint: 1024,
            settings: {
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true
            }
        },
        {
            breakpoint: 992,
            settings: {
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true
            }
        }
    ];

    //Sidebar
    $scope.definitionParameters = [];

    //Pagination
    $scope.pageSize = 9;
    $scope.currentPage = 1;

    //Main page
    $scope.technologyContext = '';
    $scope.selectedSeries = [];
    $scope.hasNoParts = false;
    $scope.isSleuthResult = false;
    $scope.builderDirectiveScope = undefined;

    //Series Images
    $scope.defaultSeriesImage = {};
    $scope.currentImage = null;
    $scope.documentationUrl = __env.documentationUrl;
    $scope.intellidataApiUrl = __env.intellidataApiUrl;
    $scope.baseUrl = `/${__env.baseUrl}`.replace(/\/+$/, ''); // remove trailing slash


    $scope.getBuilderDirectiveScope = function (builderDirectiveScope) {
        $scope.builderDirectiveScope = builderDirectiveScope;
    };

    $scope.filterBuilder = function () {
        $scope.builderDirectiveScope.filterChildren();
    };

    $scope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
        // [CE-309] If the page is forward from browser page with leaf id it means user is from KDC.
        // Send user back to KDC
        // If tech def id and browse def id are same
        // if($location.search().redirect && $location.search().id == CacheService.getDefinition().id)) {
        //     history.back();
        // } else {
        $log.debug('technologyController');
        NavigationService.syncDefinition($location.search().id);
        NavigationService.syncSleuth(oldUrl);
        //Call $scope.init() when it is back and forward between similar products
        var newUrlIdMatch = newUrl.match(/\/browsing\/technology\?.*(id=\d+)/);
        var oldUrlIdMatch = oldUrl.match(/\/browsing\/technology\?.*(id=\d+)/);
        var newUrlPnMatch = newUrl.match(/\/browsing\/technology\?.*(pn=[^&]+)/);
        var oldUrlPnMatch = oldUrl.match(/\/browsing\/technology\?.*(pn=[^&]+)/);
        if ((newUrlIdMatch !== null && oldUrlIdMatch !== null && newUrlIdMatch[1] !== oldUrlIdMatch[1])
            || (newUrlPnMatch !== null && oldUrlPnMatch !== null && newUrlPnMatch === oldUrlPnMatch && (newUrlIdMatch !== null || oldUrlIdMatch !== null))) {
            $scope.init();
        }
    });

    $scope.resetUniqueParts = function () {
        if ($scope.uniqueParts === undefined) {
            $scope.uniqueParts = [];
        }
        $scope.uniqueParts.length = 0;
    };

    $scope.splitParameterValues = function (uniquePart) {
        TechnologyService.splitParameterValuesForDisplay(uniquePart);
    };

    $scope.pageChangeHandler = function (num) {
        const startIndex = (num - 1) * $scope.pageSize;
        let lastIndex = (num * $scope.pageSize) - 1;
        if (lastIndex > ($scope.uniqueParts.length - 1)) {
            lastIndex = $scope.uniqueParts.length - 1;
        }

        const partNames = [];
        const uniqueParts = [];

        // Get uniqueParts that was not process to get quantities
        for (let i = startIndex; i <= lastIndex; ++i) {
            //Check here
            SpiceApiService.doesSpiceFileExist($scope.uniqueParts[i]);

            if ($scope.uniqueParts[i].totalParts === undefined) {
                partNames.push($scope.uniqueParts[i].uniquePn.replace(/(\{[^;]*})/gi, ''));
                uniqueParts.push($scope.uniqueParts[i]);
            } else {
                // Have to populate partCountDisplay again since partCountDisplay is reset
                $scope.uniqueParts[i].partCountDisplay = PartCountFormatterService.formatAvailability($scope.uniqueParts[i]);
            }
        }

        // Grab quantities for unique parts with no count.
        if (uniqueParts.length > 0) {
            OctopartApiService.getOctoPartQuantities(uniqueParts, function (octoQuantities) {
                //console.log(octoQuantities);
                var found;
                for (var i = startIndex; i <= lastIndex; ++i) {
                    found = false;
                    for (var j = 0; j < octoQuantities.length; ++j) {
                        if ($scope.uniqueParts[i].displayPn === octoQuantities[j].mpn ||
                            $scope.uniqueParts[i].displayPn.replace(/-/g, '') === octoQuantities[j].mpn || // Compare without dashes
                            $scope.uniqueParts[i].displayPn.replace(/ /g, '') === octoQuantities[j].mpn) { // Compare without spaces
                            found = true;
                            $scope.uniqueParts[i].totalParts = octoQuantities[j].quantity;
                            $scope.uniqueParts[i].partCountDisplay = PartCountFormatterService.formatAvailability($scope.uniqueParts[i]);
                            break;
                        }
                    }

                    if (!found) {
                        // Make sure don't overwrite already processed uniqueParts
                        if ($scope.uniqueParts[i].totalParts == undefined) {
                            $scope.uniqueParts[i].totalParts = 0;
                        }
                    }
                }
            });
        }
    };

    $scope.updateUniqueParts = function (uniqueParts) {

        $scope.resetUniqueParts();

        if (uniqueParts != null && uniqueParts.length > 0) {
            $scope.hasNoParts = false;
            //Only update compare if there is a part in comparison queue with the same leaf definition id as the technology page
            var checkCompare = false;
            for (var i = 0; i < UniquePartModelService.getCompareQueue().length; ++i) {
                if (UniquePartModelService.getCompareQueue()[i].leafDefinitionId === $scope.definition.id) {
                    checkCompare = true;
                    break;
                }
            }

            $timeout(function () {
                angular.forEach(uniqueParts, function (uniquePart) {
                    if (checkCompare) {
                        uniquePart = $scope.updateCompare(uniquePart);
                    }
                    if (CacheService.getParentDefinition() !== undefined && CacheService.getParentDefinition() !== null &&
                        CacheService.getParentDefinition().length > 0) { // If CacheService.getParentDefinition has no data. It means user redirect to home page.
                        const definitions = [ ...CacheService.getParentDefinition(), CacheService.getDefinition() ];
                        UniquePartModelService.setSpecUrl( definitions, uniquePart );
                        UniquePartModelService.setSpecProUrl( definitions, uniquePart );
                    }

                    uniquePart.formattedMessageText = $scope.formatMessageText(uniquePart.message);
                    uniquePart.partCountDisplay = $translate.instant('message__findingAvailability').valueOf();

                    UniquePartModelService.setObsoleteMessage(uniquePart);

                    $scope.uniqueParts.push(uniquePart);
                });

                $scope.pageChangeHandler(1);

                angular.forEach($scope.uniqueParts, function (uniquePart) {
                    $scope.splitParameterValues(uniquePart);
                });
            });
        } else {
            $scope.hasNoParts = true;
        }
    };

    $scope.formatMessageText = function (message) {
        if (message !== null && message.text !== null && message.text !== undefined) {
            var closeBold = false;
            while (message.text.indexOf('*') > 0) {
                if (!closeBold) {
                    message.text = message.text.replace('*', '<b>');
                    closeBold = true;
                } else {
                    message.text = message.text.replace('*', '</b>');
                    closeBold = false;
                }
            }
            return message.text;
        } else {
            return message;
        }
    };

    $scope.queryThisPart = function (similarPart) {
        if (SleuthService.getSleuthData() !== undefined) {
            SleuthService.getSleuthData().detectedUniqueParts.length = 0;
            ParameterApiService.getParametersByDefinitionAndLimiting(CacheService.getDefinition().id, function (parameters) {
                var parameterIds = [];
                parameters.forEach(function (parameter) {
                    parameterIds.push(parameter.id);
                });
                var found;
                for (var i = SleuthService.getSleuthData().queryParameterValues.length - 1; i >= 0; --i) {
                    found = false;
                    for (var j = 0; j < parameterIds.length; ++j) {
                        if (parameterIds[j] == SleuthService.getSleuthData().queryParameterValues[i].parameterId) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        SleuthService.getSleuthData().queryParameterValues.splice(i, 1);
                    }
                }

                // [CE-306] Clear sleuthData if it does not contain any limiting parameter
                if (SleuthService.getSleuthData().queryParameterValues.length === 0) {
                    SleuthService.storeSleuthData(undefined);
                    $scope.currentImage = null;
                }
                TechnologyService.cacheDefinitionBySimilarPart(similarPart, function () {
                    $scope.definition = CacheService.getDefinition();
                    $location.path('/browsing/technology').search('id', CacheService.getDefinition().id);
                    $scope.init();
                    window.scrollTo(0, 0);
                });
            });
        } else {
            TechnologyService.cacheDefinitionBySimilarPart(similarPart, function () {
                $scope.definition = CacheService.getDefinition();
                $location.path('/browsing/technology').search('id', CacheService.getDefinition().id);
                $scope.init();
                window.scrollTo(0, 0);
            });
        }
    };

    $scope.isStepFileUnavailable = function (uniquePart) {
        if (uniquePart != null) {
            return !StepFileService.isStepFileAvailable(uniquePart);
        } else {
            return true;
        }
    };

    $scope.isKSIMSupported = function ( uniquePart ) {
        if (uniquePart != null) {
            return ParameterSupportService.isKSIMSupported( uniquePart );
        } else {
            return false;
        }
    };

    $scope.isLifeCalcAvailable = function (uniquePart) {
        if (uniquePart != null) {
            return ParameterSupportService.isLifeCalculatorSupported(uniquePart);
        } else {
            return false;
        }
    };

    $scope.isEngineeringKit = function () {
        if ($scope.previousDefinition != null && $scope.previousDefinition.id == 706) {
            return true
        } else {
            return false
        }
    }

    $scope.hidePartlessSeries = function (series, parts) {
        TechnologyService.filterOutPartsWithNoSeries(series, parts);
    };

    $scope.copySeries = function (parameterValues, uniqueParts) {
        var i;
        var j;
        var selectedParameterValues = TechnologyService.getSeriesValueUsingSleuthData();
        // if(selectedParameterValues.length > 1) {
        //     selectedParameterValues.length = 1;
        // }
        $scope.selectedSeries.length = 0;
        for (i = 0; i < $scope.series.parameterValues.length; ++i) {
            $scope.series.parameterValues[i].id = parameterValues[i].id;
            $scope.series.parameterValues[i].value = parameterValues[i].value;
            $scope.series.parameterValues[i].clicked = false;

            for (j = 0; j < selectedParameterValues.length; ++j) {
                if ($scope.series.parameterValues[i].value == selectedParameterValues[j]) {
                    $scope.selectedSeries.push($scope.series.parameterValues[i].id);
                    // We want user to select datasheet for only 1 series is selected
                    if (selectedParameterValues.length === 1) {
                        // Mark series checked by Sleuth
                        TechnologyService.selectSeries($scope.series, uniqueParts,
                            $scope.series.parameterValues[i]);
                    }
                }
            }

        }

        if ($scope.series.parameterValues.length < parameterValues.length) {
            for (i = $scope.series.parameterValues.length; i < parameterValues.length; ++i) {
                $scope.series.parameterValues.push(parameterValues[i]);
                for (j = 0; j < selectedParameterValues.length; ++j) {
                    if (parameterValues[i].value == selectedParameterValues[j]) {
                        $scope.selectedSeries.push($scope.series.parameterValues[i].id);
                        // We want user to select datasheet for only 1 series is selected
                        if (selectedParameterValues.length === 1) {
                            // Mark series checked by Sleuth
                            TechnologyService.selectSeries($scope.series, uniqueParts,
                                $scope.series.parameterValues[i]);
                        }
                    }
                }
            }
        }
        $scope.series.cachedParameterValues = $scope.series.parameterValues;
    };

    $scope.showAllSeriesLists = function () {
        if ($scope.series.showAllList) {
            $scope.series.showAllList = false;
            $scope.series.showFilteredList = false;
        } else {
            $scope.series.showAllList = true;
        }

        if ($scope.series.showFilteredList) {
            $scope.series.showAllList = false;
            $scope.series.showFilteredList = false;
        }
    };


    $scope.updateSeries = function (parameterValues, uniqueParts) {
        if ($scope.series !== undefined && $scope.series !== null) {
            $scope.series.query = undefined;
            $scope.series.showDownload = false;

            // This might break something again. In future change logic for detectedUniquePart
            $scope.series.detectedUniquePart = undefined;

            if ($scope.series.parameterValues.length >= parameterValues.length) {
                $scope.series.parameterValues.length = parameterValues.length;
            }

            /*
            * This function will be called, and it will do some logic to check if we have multiple parameter values,
            * then call selectSelect based on one of them. The function selectSeries will set series.showDownload to true
            * more reliably than the check for whether there's only one parameterValues.
            */
            $scope.copySeries(parameterValues, uniqueParts);
            if ($scope.series.parameterValues.length == 1) {
                TechnologyService.selectSeries($scope.series, uniqueParts, $scope.series.parameterValues[0]);
            }
        }
    };

    $scope.getSeriesInformation = function (uniqueParts) {

        // If series is not define or its definition changed, then we want to redefine series again
        if ($scope.series === undefined || $scope.series === null || $scope.definition.id !== $scope.series.definition.id) {
            TechnologyService.getSeries($scope.definition.id,
                function (series) {
                    $scope.series = series;
                    TechnologyService.getNewParameterValues(uniqueParts, $scope.definition.id,
                        $scope.updateSeries, function (error) {
                            $log.error('An error occurred while trying to update series', error);
                        }
                    );

                }, function (error) {
                    $log.error('An error occurred while trying to get series', error);
                });
        } else {
            TechnologyService.getNewParameterValues(uniqueParts, $scope.definition.id,
                $scope.updateSeries, function (error) {
                    $log.error('An error occurred while trying to update series', error);
                }
            );
        }
    };

    $scope.initDefinition = function () {
        $scope.definition = CacheService.getDefinition();
        $scope.previousDefinition = CacheService.getParentDefinition()[CacheService.getParentDefinition().length - 1];
        $scope.technologyContext = BreadcrumbParserService.parseBreadcrumbToSentence($scope.previousDefinition);

        if ($scope.currentImage === null && $scope.definition !== undefined) {
            $scope.defaultSeriesImage = ImageProcessorService.getImage($scope.definition.definitionImage);
        } else if ($scope.currentImage !== null) {
            $scope.definition.img = $scope.currentImage;
        }

        if ($scope.definition !== undefined) {
            PartCountFormatterService.formatPartCount($scope.definition);
        }
    };

    $scope.updateCompare = function (uniquePart) {
        for (var i = 0; i < UniquePartModelService.getCompareQueue().length; ++i) {
            if (UniquePartModelService.getCompareQueue()[i].uniquePn === uniquePart.uniquePn) {
                return UniquePartModelService.getCompareQueue()[i];
            }
        }
        return uniquePart;
    };

    $scope.initializeDefinitionParameter = function (definitionParameters) {
        $scope.definitionParameters.length = 0;
        SideMenuCacheService.sidemenu.length = 0;
        angular.forEach(definitionParameters, function (definitionParameter) {
            if (definitionParameter.parameterName !== 'Series') {
                SideMenuCacheService.sidemenu.push(definitionParameter);
                $scope.definitionParameters.push(definitionParameter);
            }
            SleuthService.fillMenuValue(definitionParameter);
        });
    };

    $scope.updateUniquePartsAndSeries = function (uniqueParts) {
        $scope.updateUniqueParts(uniqueParts);
        $scope.getSeriesInformation(uniqueParts);

        // Update parametric builder after getting new parts.
        SideMenuCacheService.sidemenu.length = 0;
        angular.forEach($scope.definitionParameters, function (definitionParameter) {
            if (definitionParameter.parameterName !== 'Series') {
                SideMenuCacheService.sidemenu.push(definitionParameter);
            }
            SleuthService.fillMenuValue(definitionParameter);
        });
    };

    $scope.scrollToMessageHandler = function () {
        $window.scrollTo(0, 600);
    };

    $scope.initializeUniquePartsAndSeries = function () {
        // If user searched and found results.
        if (SleuthService.getSleuthData() !== undefined) {
            $scope.isSleuthResult = true;
            TechnologyService.updateUniquePartsAndSeriesBySleuth($scope.definition.id, $scope.updateUniquePartsAndSeries);
            if (SleuthService.getSleuthData().message.type == 'ERROR') {
                $scope.scrollToMessageHandler();
            }
        } else {  // Technology page came by browse
            SpinnerLoadingService.showLoading($scope.loadingPartsMessage);
            UniquePartApiService.getUniquePartsByDefinitionAndDisplayArea($scope.definition.id, 'COMPONENT_EDGE_PART_SUMMARY', function (uniqueParts) {
                $scope.updateUniquePartsAndSeries(uniqueParts);
                SpinnerLoadingService.hideLoading();
            });
        }
    };

    $scope.init = function () {
        $log.debug('Location', $location.path());
        $scope.isSleuthResult = false;

        $scope.initDefinition();

        if ($scope.definition !== undefined) {
            $scope.similarProducts.length = 0;
            TechnologyService.getSimilarParts(function (similarProducts) {
                $timeout(function () {
                    $scope.similarProducts = similarProducts;
                });
            });

            DefinitionParameterApiService.getDefinitionParameterByDefinitionAndDisplayArea($scope.definition.id, 'COMPONENT_EDGE_TECHNOLOGY_BUILDER', function (definitionParameters) {
                $scope.initializeDefinitionParameter(definitionParameters);
            }, function (error) {
                // Some error handling here.
                $log.error('error: ' + error);
            });

            $translate('label__loading__parts', 'en').then(function (value) {
                $scope.loadingPartsMessage = value;
                $scope.initializeUniquePartsAndSeries();
            });
        }

        //// The current page doesn't reset after a new sleuth search, so we do that here.
        if (SleuthService.getSleuthData() !== undefined) {
            $scope.currentPage = 1;
        }
    };

    if (CacheService.getDefinition()) {
        $scope.init();
    } else {
        DefinitionModelService.getModelInit();
    }

    $scope.handleSleuthChanges = function () {
        if (SleuthService.getSleuthData() === undefined) {
            $scope.series = undefined;
            if ($scope.definition !== undefined) {
                $scope.definition.img = $scope.defaultSeriesImage;
            }
        }
        if ($location.path() === APP_ROUTES.PART_LISTING.path) {
            $scope.init();
        }
    };

    NotifyingService.subscribeToSleuthChanges($scope, $scope.handleSleuthChanges);
    NotifyingService.subscribeToModelServiceInit($scope, $scope.init);


    $scope.findRootDefinition = function (definitions, currentDefinition) {
        var def;
        for (var i = 0; i < definitions.length; ++i) {
            if (definitions[i].childDefinitions.length > 0) {
                def = $scope.findRootDefinition(definitions[i].childDefinitions, currentDefinition);
            } else {
                if (definitions[i].id === currentDefinition.id) {
                    def = definitions[i];
                }
            }
            if (def !== undefined) {
                def = definitions[i];
                break;
            }
        }
        return def;
    };

    $scope.onChangeUniqueParts = function (response) {
        if ($scope.series.query !== undefined) {
            for (var i = 0; i < response.detectedUniqueParts.length; ++i) {
                if (response.detectedUniqueParts[i].series !== undefined && response.detectedUniqueParts[i].series !== null &&
                    response.detectedUniqueParts[i].series.id === $scope.series.query.id) {
                    $scope.series.detectedUniquePart = response.detectedUniqueParts[i];
                    break;
                }
            }
        } else {
            $scope.series.showDownload = false;
        }
    };

    $scope.handleSeriesClick = function (isClicked) {
        (isClicked === undefined) ? isClicked = false : isClicked;
        $scope.series.showDownload = isClicked;
    };

    $scope.resetSeriesInput = function () {
        $scope.handleSeriesClick(false);
        if ($scope.series.query != null) {
            $scope.series.query.selectedFormattedValue = '';
        }
        if ($scope.selectedSeries != null) {
            $scope.selectedSeries.length = 0;
        }
        $scope.removeSeriesFromSleuthData();
        $timeout(
            function () {
                $scope.filterBuilder();
            },
            10
        );
    };

    // Remove series
    $scope.removeSeriesFromSleuthData = function () {
        if (SleuthService.getSleuthData() !== undefined && SleuthService.getSleuthData().queryParameterValues !== undefined) {
            for (var i = SleuthService.getSleuthData().queryParameterValues.length - 1; i >= 0; i--) {
                if (SleuthService.getSleuthData().queryParameterValues[i].parameterId === 3) {
                    SleuthService.getSleuthData().queryParameterValues.splice(i, 1);
                }
            }
        }
    };

    $scope.handleSeriesSelectClick = function (series) {
        $scope.handleSeriesClick();
        $scope.setCurrentImage(series);

        $scope.series.query = series;
        $scope.series.query.selectedFormattedValue = $scope.series.query.formattedValue;
        $scope.series.showAllList = false;
        $scope.series.showFilteredList = false;
        // We want user to select only 1 series for datasheet
        $scope.selectedSeries.length = 0;
        $scope.selectedSeries.push(series.id);
        $scope.removeSeriesFromSleuthData();
        // $scope.definition.img = $scope.currentImage;

        $timeout(
            function () {
                $scope.filterBuilder();
            },
            10
        );
    };

    $scope.$parent.isopen = ($scope.$parent['default'] === $scope.item);
    $scope.$watch('isopen', function (newValue, oldValue, scope) {
        scope.$parent.isopen = newValue;
    });

    $scope.toggleOpen = function () {
        $log.info('Open');
    };

    $scope.setCurrentImage = function (series) {
        if (typeof($scope.definition) !== 'undefined' &&
            typeof($scope.definition.seriesImages) !== 'undefined' &&
            $scope.definition.seriesImages != null) {
            var seriesImages = $scope.definition.seriesImages;
            for (var i = 0; i < seriesImages.length; i++) {
                if (series.id === parseInt(seriesImages[i].seriesParameterValue.id)) {
                    // Series-specific image case
                    $scope.currentImage = {
                        src: seriesImages[i].url,
                        title: seriesImages[i].title,
                        alt: seriesImages[i].alt
                    };
                    break;
                }
            }
        }
        // if we don't get a series-specific image, set as default
        if ($scope.currentImage === null) {
            $scope.currentImage = $scope.defaultSeriesImage;
        }
    };

    $scope.handleSeriesRadioClick = function (series) {
        series.clicked = !series.clicked;

        $scope.handleSeriesClick(series.clicked);
        $scope.setCurrentImage(series);


        // We want user to select only 1 series for datasheet
        $scope.selectedSeries.length = 0;
        if (series.clicked == false) {

            let foundOtherClickedSeries = false;
            for (let i = 0; i < $scope.series.parameterValues.length; ++i) {
                if ($scope.series.parameterValues[i].clicked) {
                    $scope.series.query = $scope.series.parameterValues[i];
                    foundOtherClickedSeries = true;
                    break;
                }
            }
            if (!foundOtherClickedSeries) {
                $scope.series.query = undefined;
                $scope.selectedSeries.length = 0;
            }
        } else {
            $scope.series.query = series;
            $scope.selectedSeries.push(series.id);
        }
        $timeout(
            function () {
                $scope.filterBuilder();
            },
            10
        );
    };

    $scope.displayParameterName = function (parameterValue) {
        if (parameterValue.parameter === undefined) {
            return ContainerInfoApiService.getDisplayNameByDisplayNames(
                parameterValue.parameterDisplayNames,
                CacheService.getConfigurationInfo().language
            );
        }
        return parameterValue.parameter.name;
    };

    $scope.buildDatasheetUrl = function (uniquePart) {
        if (uniquePart != null) {
            return DocFinderFileService.buildDataSheetUrl(uniquePart);
        }
    };

    $scope.buildStepUrl = function (uniquePn) {
        if (uniquePn != null) {
            return DocFinderFileService.buildStepUrl(uniquePn);
        }
    };

    $scope.fetchPrevious = function () {
        CacheService.storeDefinition(CacheService.getParentDefinition().pop());
        $scope.previousDefinition = CacheService.getParentDefinition()[CacheService.getParentDefinition().length - 1];

        if (SleuthService.getSleuthData()) {
            // Commented out for when user searched for uniquePn. Updated TechnologyService.js to remove
            // detectedUniqueParts if user selected different definition. Commented out on 9/6/2018 if it doesn't
            // cause any problem by 3/6/2018 remove it.
            // if(SleuthService.getSleuthData().detectedUniqueParts != undefined) {
            //     SleuthService.getSleuthData().detectedUniqueParts.length = 0;
            // }
            SleuthService.getSleuthData().message = {type: undefined, text: ''};
        }

        $timeout(
            function () {
                $scope.$apply(function () {
                    $location.path('/browsing').search('id', CacheService.getDefinition().id);
                });
            },
            10
        );
    };

    $scope.onClickSeries = function () {
        $scope.series.setActiveClass = false;
    };

    $scope.onSTEPClick = function (event, uniquePart) {
        $scope.trackStepDownload(uniquePart.uniquePn, `${uniquePart.uniquePn}.step`);
    };

    $scope.SpiceIcoUrl = SpiceIcoUrl;

    $scope.traverse = function (partObject) {
        //set the uniquePn in the query string
        $location.search('pn', partObject.uniquePn);
        $location.search('id', null);
        CacheService.storeUniquePart(partObject);
        $timeout(
            function () {
                $scope.$apply(function () {
                    $location.path('/distributor');
                });
            },
            10
        );
    };

    $scope.setUnclick = function (parameterValues) {
        angular.forEach(parameterValues, function (value) {
            if (value.clicked !== undefined) {
                value.clicked = false;
            }
        });
    };

    $scope.formatLargeNumber = function (number) {
        return PartCountFormatterService.formatLargeNumber(number);
    };

    $scope.formatNumber = function (number) {
        return PartCountFormatterService.formatAvailability(number);
    };

    $scope.formatAlias = function (pn) {
        return PartNumberFormatterService.formatPn(pn);
    };

    $scope.sleuthDataComparison = function (searchLabel) {
        $translate(searchLabel, 'en').then(function (value) {
            var fauxPart = null;
            for (var i = 0; i < UniquePartModelService.getCompareQueue().length; ++i) {
                if (UniquePartModelService.getCompareQueue()[i].uniquePn === 'Search') {
                    fauxPart = UniquePartModelService.getCompareQueue()[i];
                    break;
                }
            }
            if (fauxPart == null) {
                fauxPart = SleuthService.getSleuthDataFauxPart(CacheService.getDefinition().id, value.valueOf());
            }
            $scope.selectForComparison(fauxPart);
        });
    };

    $scope.selectForComparison = function (uniquePart) {
        var errorMessage = UniquePartModelService.updateComparison(uniquePart);
        if (errorMessage != null) {
            alert(errorMessage);
        }
    };

    $scope.removeSleuthData = function () {
        SleuthService.removeSleuthData();
    };

    $scope.clearSearchBar = function () {
        CacheService.storeOriginalQueryInput(undefined);
    };

    /**
     * Handle Home Click
     *
     * Handles the redirection of linking home for mobile especially.
     */
    $scope.handleHomeClick = function () {
        $location.path('/');
    };

    /* GOOGLE ANALYTICS TRACKING */
    $scope.trackSpecSheet = function (title, url) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'PDF',
                eventAction: 'view_specsheet',
                eventLabel: 'Part: ' + title + '; URL: ' + url
            });
        }
    };

    $scope.trackProSpecSheet = function ( title, url ) {
        if ($window.ga) {
            $window.ga( 'send', {
                hitType: 'event',
                eventCategory: 'PDF',
                eventAction: 'view_pro-specsheet',
                eventLabel: 'Part: ' + title + '; URL: ' + url,
            } );
        }
    };

    $scope.trackStepDownload = function (title, stepFile) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'STEP',
                eventAction: 'download',
                eventLabel: 'Part: ' + title + '; STEP: ' + stepFile
            });
        }
    };

    $scope.trackKSIMNavigation = function (title, message) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'KSIM',
                eventAction: 'navigate',
                eventLabel: 'Part: ' + title + '; Message: ' + message
            });
        }
    };

    $scope.trackViewPricingClick = function (pn) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'viewPricing',
                eventAction: 'click',
                eventLabel: 'Part Number: ' + pn
            });
        }
    };

    $scope.trackRequestSampleClick = function (pn) {
        if ($window.ga) {
            $window.ga('send', {
                hitType: 'event',
                eventCategory: 'requestSample',
                eventAction: 'click',
                eventLabel: 'Part Number: ' + pn
            });
        }
    };

    /**
     * Check to see if the series is supported by the Inductor Loss Calculator.
     * If it is, then link the user to the web application.**/
    $scope.isSeriesInInductorLossCalculator = function (series) {
        const supportedSeries = ['MPC', 'MPCG', 'MPCH', 'MPLC', 'MPLCG', 'MPLCH'];
        return supportedSeries.indexOf(series) >= 0;
    };

    $scope.displayDefinitionName = function (definition) {
        if (definition === undefined) {
            return '';
        }
        if (CacheService.getConfigurationInfo() !== undefined) {
            const displayName = ContainerInfoApiService.getDisplayName(definition, CacheService.getConfigurationInfo().language);
            if (displayName === null) {
                return ContainerInfoApiService.getDisplayName(definition, 'ENGLISH');
            } else {
                return displayName;
            }
        }
    };

    $scope.getDisplayParameterName = function (parameterValue) {
        const displayName = ContainerInfoApiService.getDisplayNameByDisplayNames(
            parameterValue.parameterDisplayNames,
            CacheService.getConfigurationInfo().language
        );

        if (displayName !== null) {
            return displayName;
        }

        return ContainerInfoApiService.getDisplayNameByDisplayNames(
            parameterValue.parameterDisplayNames,
            'ENGLISH'
        );
    };

    $scope.displayValue = function (parameterValue) {
        if (parameterValue.formattedValue !== undefined && parameterValue.formattedValue !== null) {
            return parameterValue.formattedValue;
        }

        let translatedValue = null;
        if (CacheService.getConfigurationInfo() !== undefined) {
            translatedValue = ContainerInfoApiService.getDisplayName(parameterValue, CacheService.getConfigurationInfo().language);
        }
        if (translatedValue == null) {
            translatedValue = parameterValue.value;
        }
        return translatedValue;
    };

    $scope.getPartCountLabelByDefinition = function (definition) {
        return PartCountFormatterService.getLabelByDefinition(definition);
    }
}
